export default __webpack_public_path__ + "static/media/startup_hyd.27a07509.png";